import { BellBadgeIcon } from './BellBadgeIcon';

/**
 * author: Michael Irigoyen
 * id 9DA90BB6-B525-47A8-879F-66EC572FE31B
 * name bell-badge
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-badge.svg
 * tags
 * - Notification 
 */
export const BellNotificationIcon = BellBadgeIcon;
export default BellNotificationIcon